export const commandHudId = 'commandHud';
